const formatRupees = (cents) => {
  const rupees = Math.round(cents) / 100;
  const rounded = Math.round(rupees * 100) / 100;
  const amount = Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2);
  return `₹${amount}`;
};

document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.complete-your-clean');
  if (!section) return;

  const totalValueEl = section.querySelector('.complete-your-clean__total-value');
  const cta = section.querySelector('.complete-your-clean__cta');
  const ctaPriceEl = section.querySelector('.complete-your-clean__cta-price');
  let busy = false;

  const formatTotal = (cents) => formatRupees(cents);

  const getToggles = () => [...section.querySelectorAll('.complete-your-clean__toggle')];

  const updateTotal = () => {
    const selectedToggles = getToggles().filter((toggle) => toggle.classList.contains('is-on'));
    const totalCents = selectedToggles.reduce(
      (sum, toggle) => sum + parseInt(toggle.dataset.priceCents || '0', 10),
      0
    );

    if (totalValueEl) totalValueEl.textContent = formatTotal(totalCents);
    if (ctaPriceEl) ctaPriceEl.textContent = formatTotal(totalCents);
    if (cta) cta.disabled = selectedToggles.length === 0;
  };

  section.addEventListener('click', async (event) => {
    const toggle = event.target.closest('.complete-your-clean__toggle');
    if (toggle) {
      const isOn = toggle.classList.toggle('is-on');
      toggle.setAttribute('aria-checked', String(isOn));
      const label = toggle.parentElement.querySelector('.complete-your-clean__toggle-label');
      if (label) label.textContent = isOn ? 'In cart' : 'Add';
      updateTotal();
      return;
    }

    const ctaButton = event.target.closest('.complete-your-clean__cta');
    if (!ctaButton || ctaButton.disabled || busy) return;

    const items = getToggles()
      .filter((t) => t.classList.contains('is-on'))
      .map((t) => ({ id: parseInt(t.dataset.variantId, 10), quantity: 1 }))
      .filter((item) => item.id);

    if (items.length === 0) return;

    busy = true;
    ctaButton.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error(`Cart error: ${response.status}`);

      document.dispatchEvent(
        new CustomEvent('theme:cart:updated', {
          detail: { source: 'complete-your-clean' },
          bubbles: true,
        })
      );

      const cartIcon = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
      if (cartIcon) cartIcon.click();
    } catch (error) {
      console.error('complete-your-clean add-to-cart failed:', error);
    } finally {
      busy = false;
      ctaButton.disabled = false;
    }
  });

  updateTotal();
});
